export default function iOS(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return true;
  }

  const hasMultipleTouchPoints =
    typeof navigator !== 'undefined' &&
    'maxTouchPoints' in navigator &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1;

  if (
    /macintosh/.test(userAgent) &&
    typeof document !== 'undefined' &&
    'ontouchend' in document &&
    hasMultipleTouchPoints
  ) {
    return true;
  }

  if (
    /macintosh/.test(userAgent) &&
    /safari/.test(userAgent) &&
    !/chrome|firefox|opera|edge/.test(userAgent)
  ) {
    return true;
  }

  return false;
}
